import { ThunkDispatch } from "core-integration/src/store";
import { unbanLeagueEntry } from "core-integration/src/store/leagues/thunks";
import { IPrivateLeagueAdmin } from "core-integration/src/store/leagues/types";
import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Button from "../../Button";
import SubHeading from "../../SubHeading";

interface IOwnProps {
  league: IPrivateLeagueAdmin;
}

type Props = IOwnProps & WithTranslation;

const RemoveBan: React.FC<Props> = ({ league, t }) => {
  const dispatch = useDispatch<ThunkDispatch>();

  if (!league.bans.length) {
    return null;
  }

  return (
    <>
      <SubHeading>
        {t("removeBan.title", "Remove league suspensions")}
      </SubHeading>
      <p>
        {t(
          "removeBan.description",
          "If a player has a suspension removed, they will need to join the league again.",
        )}
      </p>
      <ul>
        {league.bans.map((b) => (
          <li key={b.entry}>
            {b.player_name}
            <Button
              onClick={() =>
                dispatch(unbanLeagueEntry(league.id, { entry: b.entry }))
              }
            >
              {t("removeBan.suspendPlayer", "Remove suspension")}
            </Button>
          </li>
        ))}
      </ul>
    </>
  );
};

export default withTranslation()(RemoveBan);
